import React, { useState, useEffect } from "react";
import { withNamespaces } from "react-i18next";
import axios from "axios";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import CreateEditUserDepartment from "./CreateEditUserDepartment";

const UsersDepartmentsList = (props) => {
    const link = localStorage.getItem('link') + '/api/UserDepartments';
    const activeRights = JSON.parse(localStorage.getItem("rights"));
    const canCreate = activeRights.includes("UserDepartments.Create");
    const canEdit = activeRights.includes("UserDepartments.Update");
    const canDel = false;//activeRights.includes("UserDepartments.Delete");

    const [currentEditEntry, setCurrentEditEntry] = useState();
    const [departments, setDepartments] = useState([]);

    const [loaderShow, setLoaderShow] = useState(false);
    const [popUpShow, setPopUpShow] = useState(false);

    axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("JWT");
    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        setLoaderShow(true);

        axios.get(link, {}).then((response) => {
            setDepartments(response.data);
            setLoaderShow(false);
        })
            .catch((error) => {
                console.error("Error while loading Data", error);
                setLoaderShow(false);
            });
    }

    const editCreateEntry = (roleData) => {
        setCurrentEditEntry(roleData);
        setPopUpShow(true);
    }

    const deleteEntry = (entry) => {
        confirmAlert({
            message: props.t("allgemein.bestaetigen"),
            buttons: [
                {
                    label: props.t("allgemein.ja"),
                    onClick: () =>
                        axios
                            .delete(link + "?id=" + entry.id)
                            .then(() => {
                                setDepartments(b => b.filter(b => b.id !== entry.id));
                            })

                            .catch((error) => {
                                console.error("Error while deleting", error);
                            }),
                },
                {
                    label: props.t("allgemein.nein"),
                },
            ],
        });
    };

    const list = () => {
        let list = [];

        for (let i = 0; i < departments.length; i++) {
            let entry = departments[i];
            list.push(
                <tr key={entry.id}>
                    <td>{entry.name}</td>
                    <td>
                        {canEdit && (
                            <i
                                className="bx bx-edit bx-sm"
                                style={{ marginLeft: "10px" }}
                                onClick={() => editCreateEntry(entry)}
                                title={props.t("allgemein.Bearbeiten")}
                            ></i>
                        )}
                        {canDel && (
                            <i
                                className="bx bx-trash bx-sm"
                                style={{ marginLeft: "10px" }}
                                onClick={() => deleteEntry(entry)}
                                title={props.t("allgemein.Loeschen")}
                            ></i>
                        )}
                    </td>
                </tr>
            );
        }

        return list;
    }

    return (
        <>
            {popUpShow === true && (
                <div style={{ width: "80%", margin: "auto" }}>
                    <CreateEditUserDepartment
                        translation={props.t}
                        entryId={currentEditEntry?.id}
                        entryChanged={() => {
                            setCurrentEditEntry(null);
                            setPopUpShow(false);
                            loadData();
                        }}
                    />
                </div>
            )}
            {popUpShow === false && (
                <div style={{ width: "50%", margin: "auto" }}>
                    <h3>{props.t("administration.userDepartments.listheader")}</h3>
                    <div className="box-name">
                        {props.t("administration.userDepartments.listheader")}
                    </div>
                    <div style={{ overflow: "auto" }}>
                        <table id="manageRolesAndRightsTable">
                            <thead>
                            <tr>
                                <th>{props.t("allgemein.name")}</th>
                                <th>
                                    {canCreate && (
                                        <button
                                            className="button"
                                            id="pop-up-button"
                                            style={{ width: "80px" }}
                                            onClick={() => editCreateEntry()}
                                        >
                                            {props.t("allgemein.Neu")}
                                        </button>
                                    )}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                {list()}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
};

export default withNamespaces()(UsersDepartmentsList);
